
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/use-toast";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";

// Form schema for WordPress credentials
const formSchema = z.object({
  siteId: z.string().min(1, "Site ID is required"),
  siteUrl: z.string().url("Please enter a valid URL"),
  wpUsername: z.string().min(1, "WordPress username is required"),
  wpPassword: z.string().min(1, "WordPress password is required"),
});

export const WordPressConnectForm = () => {
  // Initialize form
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      siteId: "1", // Default to the first website ID
      siteUrl: "https://your-wordpress-site.com",
      wpUsername: "",
      wpPassword: "",
    },
  });

  const onSubmit = (values: z.infer<typeof formSchema>) => {
    console.log("Form submitted with values:", values);
    
    // In a real app, this would send the credentials to the server
    toast({
      title: "WordPress site connected",
      description: "Your WordPress site has been connected to the backup service.",
    });
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4 mt-4">
        <FormField
          control={form.control}
          name="siteUrl"
          render={({ field }) => (
            <FormItem>
              <FormLabel>WordPress Site URL</FormLabel>
              <FormControl>
                <Input placeholder="https://your-wordpress-site.com" {...field} />
              </FormControl>
              <FormDescription>
                Enter the full URL of your WordPress site
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="wpUsername"
          render={({ field }) => (
            <FormItem>
              <FormLabel>WordPress Admin Username</FormLabel>
              <FormControl>
                <Input placeholder="admin" {...field} />
              </FormControl>
              <FormDescription>
                Administrator username with permission to install plugins
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="wpPassword"
          render={({ field }) => (
            <FormItem>
              <FormLabel>WordPress Admin Password</FormLabel>
              <FormControl>
                <Input type="password" placeholder="•••••••••" {...field} />
              </FormControl>
              <FormDescription>
                Your password is securely encrypted and only used for backup operations
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <Button type="submit" className="w-full">
          Connect WordPress Site
        </Button>
      </form>
    </Form>
  );
};
